const _parseId = (url) => {
    try {
        const regexDrive = /drive\.google\.com\/open\?id=(.+)|drive\.google\.com\/file\/d\/(.+)\/|docs\.google\.com\/uc\?export=download&id=(.+)/;
        if (regexDrive.test(url)) {
            const execRegex = regexDrive.exec(url);
            const id1 = execRegex[1];
            const id2 = execRegex[2];
            const id3 = execRegex[3];
            if (id1) return id1;
            if (id2) return id2;
            if (id3) return id3;
        }

        return null;
    } catch (e) {
        return null;
    }
};

const parseGGDriver = (url) => {
    if (!url) return url;

    const id = _parseId(url);
    // if (id) return `https://docs.google.com/uc?export=download&id=${id}`;
    if (id) return `https://lh3.googleusercontent.com/d/${id}`;

    return url;
};

export default parseGGDriver;